export const pushMicrosoftConversion = (action) => {
    try {
        if (!process.browser || !window || !window.uetq) return false
        return window.uetq.push('event', action, {})
    } catch (error) {
        console.error('Issue with Microsoft conversion', error)
        return false
    }
}

export const microsoftConversions = {
    traffic : {
        manualFlow: {
            // user submitted a traffic ticket via manual submission
            submissionCompleted: 'traffic_ticket_submission_completed',
            temp: 'traffic_ticket_with_status_temp',
            pendingConf: 'traffic_ticket_status_pendingConf'
        },
        fetcherFlow : {
            informationAdded: 'traffic_fetcher_information_added',
            // user viewed results page (with tickets!)
            resultsPage: 'traffic_fetcher_results',
            submissionCompleted: 'traffic_fetcher_transaction_completed'
        }
    },
    divorce : {
        fetcherFlow : {
            informationAdded: 'divorce_fetcher_information_added',
            // user viewed results page (with cases!)
            resultsPage: 'divorce_fetcher_results',
        }
    },
    parking: {
        fightFlow: {
            submissionCompleted: 'parking_ticket_submission_completed'
        },
        payFlow: {
            submissionCompleted: 'parking_ticket_guilty_payment_completed'
        },
        payFlowNYC: {
            submissionCompleted: 'ny_parking_ticket_guilty_payment_completed'
        },
    },
    payments: {
        // user adds a payment method
        addPaymentMethod: 'new_payment_method_saved'
    },
    general: {
        // user signs up
        signup: 'user_registration_completed'
    },
    plate: {
        plateCreated: 'new_plate_saved'
    },
} 
